export default function TimesplitPill({ timesplit }: { timesplit: string }) {
  let classes;
  if (timesplit === '50-50') classes = 'text-green bg-green-light-10 border-green';
  if (timesplit === '60-40') classes = 'text-blue bg-blue-light-10 border-blue';
  if (timesplit === '70-30') classes = 'text-red bg-red-light-10 border-red';
  if (timesplit === '80-20') classes = 'text-orange bg-orange-light-10 border-orange';

  return (
    <span className="flex h-full">
      <span className={`rounded-3xl border px-2 py-[2px] text-[11px] font-bold ${classes}`}>
        {timesplit.replace('-', '/')}
      </span>
    </span>
  );
}
